import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import _ from 'lodash';

import commissionSchemeConstants from '../constants/commission-scheme-constants';
import constants from '../../../../common/constants';

import '../styles/trading-activity-table.css';

class CommissionTable extends Component {
  renderTableHead(items) {
    const { t } = this.context;

    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <th key={index}>{t(item.label)}</th>;
      });
    } else return null;
  }

  renderTableBody(items) {
    const { t } = this.context;

    const filtered = _.groupBy(items, 'promotion_id');

    return (
      <tbody className="trading-activity-table__table__body">
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.VERIFIED')}</td>
          <td>{t('COMMISSION_TABLE.VERIFIED_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.verified.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.verified.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.LEVEL_GOAL')}</td>
          <td>{t('COMMISSION_TABLE.BRONZE_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.bronze.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.bronze.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.LEVEL_GOAL')}</td>
          <td>{t('COMMISSION_TABLE.SILVER_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.silver.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.silver.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.LEVEL_GOAL')}</td>
          <td>{t('COMMISSION_TABLE.GOLD_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.gold.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.gold.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.LEVEL_GOAL')}</td>
          <td>{t('COMMISSION_TABLE.DIAMOND_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.diamond.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.diamond.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
        <tr className="trading-activity-table__table__body__row">
          <td>{t('COMMISSION_TABLE.LEVEL_GOAL')}</td>
          <td>{t('COMMISSION_TABLE.CRYSTAL_LEVEL')}</td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.crystal.tier_1, filtered)} displayType={'text'} />
          </td>
          <td>
            <NumberFormat thousandSeparator={true} prefix={'$'} value={this.getValue(constants.promotion_settings.crystal.tier_2, filtered)} displayType={'text'} />
          </td>
        </tr>
      </tbody>
    );
  }

  getValue(promotionId, promotions) {
    return promotions[promotionId] && promotions[promotionId].length > 0 ? promotions[promotionId][0].amount : '';
  }

  render() {
    const { t } = this.context;
    const { promotions } = this.props;

    return (
      <div className="trading-activity-table table-responsive">
        <table className="trading-activity-table__table">
          <thead className="trading-activity-table__table__head">
            <tr className="trading-activity-table__table__head__row">
              <th className="trading-activity-table__table__head__row__title">{t('COMMISSION_TABLE.TITLE')}</th>
              <th />
              <th />
              <th />
            </tr>
            <tr className="trading-activity-table__table__head__row">{this.renderTableHead(commissionSchemeConstants.commission_table)}</tr>
          </thead>
          {this.renderTableBody(promotions)}
        </table>
      </div>
    );
  }
}

CommissionTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CommissionTable;



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-table.js